// hooks
import { useScrollBarWidth } from "./useScrollBarWidth.js";

/**
 * useDisableBodyScroll: typically used for modals to disable the body, and let the modal take over
 *  e.g. no scrolling in the background of the modal
 *
 * @param {Object} disableIosTouchMove: disable iOs touchemove to truly disable scroll
 *      ios does introduces a lot of issues with focused/positioned elements - we can disable
 *      touchmove all together while modal is open
 *      not good if you want scrolling in a modal
 * @returns
 */

// define outside so this never gets cached - or useCallback
const preventScroll = e => e.preventDefault();

export const useDisableBodyScroll = ({ disableIosTouchMove = false } = {}) => {
    const { scrollbarWidthRem } = useScrollBarWidth();

    const disableBody = () => {
        if (typeof document !== "undefined" && document.body) {
            document.body.style.paddingRight = scrollbarWidthRem;
            document.body.style.overflow = "hidden";
            if (disableIosTouchMove) {
                document.addEventListener("touchmove", preventScroll, {
                    passive: false
                });
            }
        }
    };
    const enableBody = () => {
        if (typeof document !== "undefined" && document.body) {
            document.body.style.paddingRight = "";
            document.body.style.overflow = "";
            if (disableIosTouchMove) {
                document.removeEventListener("touchmove", preventScroll);
            }
        }
    };

    const disableBodyScroll = shouldDisable => {
        shouldDisable ? disableBody() : enableBody();
    };

    return {
        disableBodyScroll
    };
};
